import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserRoleService } from './role.service';
import {
  CurrencyCode,
  DEFAULT_CURRENCY_CODE,
  getCurrencySymbol,
  normalizeCurrencyCodeStrict,
  setCurrencyDisplayCountry,
  shouldUseZeroDecimalsForCountry,
} from 'src/app/core/utils/currency.utils';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly currencySymbolSubject = new BehaviorSubject<string>(getCurrencySymbol(DEFAULT_CURRENCY_CODE) || '€');
  private readonly currencyCodeSubject = new BehaviorSubject<CurrencyCode>(DEFAULT_CURRENCY_CODE);
  private readonly countrySubject = new BehaviorSubject<string | null>(null);
  private readonly forceZeroDecimalsSubject = new BehaviorSubject<boolean>(false);
  public readonly currencySymbol$: Observable<string> = this.currencySymbolSubject.asObservable();
  public readonly currencyCode$: Observable<CurrencyCode> = this.currencyCodeSubject.asObservable();
  public readonly country$: Observable<string | null> = this.countrySubject.asObservable();
  public readonly forceZeroDecimals$: Observable<boolean> = this.forceZeroDecimalsSubject.asObservable();

  constructor(private readonly userRoleService: UserRoleService) {
    this.loadCurrencySettings();
  }

  private loadCurrencySettings() {
    this.userRoleService.currentUser$.subscribe(user => {
      const code = normalizeCurrencyCodeStrict(user?.currency) ?? DEFAULT_CURRENCY_CODE;
      this.currencyCodeSubject.next(code);
      const symbol = getCurrencySymbol(code) || getCurrencySymbol(DEFAULT_CURRENCY_CODE) || '€';
      this.currencySymbolSubject.next(symbol);

      const country = user?.country ?? null;
      this.countrySubject.next(country);
      setCurrencyDisplayCountry(country);
      this.forceZeroDecimalsSubject.next(shouldUseZeroDecimalsForCountry(country));
    });
  }

  public getCurrentCurrencySymbol(): string {
    return this.currencySymbolSubject.value;
  }

  public getCurrentCurrencyCode(): CurrencyCode {
    return this.currencyCodeSubject.value;
  }

  public getCurrentCountry(): string | null {
    return this.countrySubject.value;
  }

  public shouldForceZeroDecimals(): boolean {
    return this.forceZeroDecimalsSubject.value;
  }
} 
